import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { RouteAnnouncer } from "./RouteAnnouncer";
import { CookieBanner } from "./CookieBanner";

export function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-brand-ink focus:px-4 focus:py-2 focus:text-brand-paper"
      >
        Saltar al contenido principal
      </a>
      <RouteAnnouncer />
      <SiteHeader />
      <main id="main" tabIndex={-1} className="focus:outline-none">
        <Outlet />
      </main>
      <SiteFooter />
      <CookieBanner />
    </>
  );
}
